import cs from 'classnames';

import renderButton from './renderButton';

const Footer = ({
  footer,
  footerActions,
  handleClose,
  className,
  isFooter = true,
  onSubmitClickCapture
}) => {
  // A custom footer that resolves to null still keeps its (empty) footer slot.
  if (footer != null) {
    return (
      <div
        className={cs('Modal__footer h-[56px] min-w-0', className)}
        onClickCapture={onSubmitClickCapture}>
        {typeof footer === 'function' ? footer({ close: handleClose }) : footer}
      </div>
    );
  }

  const otherContent = footerActions?.other;
  const primaryButton = footerActions?.primary;
  const secondaryButton =
    footerActions?.secondary === undefined
      ? { text: 'Close', onClick: handleClose }
      : footerActions?.secondary;

  const hasContent = isFooter && (otherContent || primaryButton || secondaryButton);

  if (!hasContent) return null;

  // Three actions in one nowrap row runs off the side of a phone — the last button ends up
  // half off-screen and unreachable. Callers already dress their buttons with `xs:w-full`
  // for this; the row just never gave them anywhere to go. Only the three-slot case stacks,
  // and only on a phone: the two-button footers every other modal uses are left alone, and
  // a tablet has the width for one row.
  const isCrowded = !!otherContent && !!primaryButton && !!secondaryButton;

  return (
    <div className={cs('Modal__footer h-[56px] min-w-0', isCrowded && 'xs:h-auto', className)}>
      <div
        className={cs(
          'flex w-full items-center justify-between gap-3',
          isCrowded && 'xs:flex-col-reverse xs:items-stretch'
        )}>
        <div className={cs('flex items-center', isCrowded && 'xs:w-full')}>{otherContent}</div>
        <div
          className={cs(
            'flex items-center gap-3',
            isCrowded && 'xs:w-full xs:flex-col-reverse xs:items-stretch'
          )}>
          {renderButton({
            config: secondaryButton,
            defaultText: 'Close',
            defaultVariant: 'tertiary',
            defaultOnClick: handleClose,
            defaultDataQa: 'close-modal-btn'
          })}
          {renderButton({
            config: primaryButton,
            defaultText: 'Save',
            defaultVariant: 'primary',
            defaultDataQa: 'primary-modal-btn'
          })}
        </div>
      </div>
    </div>
  );
};

export default Footer;
